













import { defineComponent, onUpdated, onMounted } from '@vue/composition-api';

interface PropsInterface {
    id: number;
    sellers?: string;
    addresses?: string;
    postcodes?: string;
    mapsLinks?: string;
}

export default defineComponent({
    name: 'AddressCell',
    props: {
        id: { type: Number, required: true },
        sellers: { type: String, required: false },
        addresses: { type: String, required: false },
        postcodes: { type: String, required: false },
        mapsLinks: { type: String, required: false }
    },
    setup (props: PropsInterface, { refs, root }) {
        const initFancybox = () => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            $(refs.fancybox).fancybox({
                padding: 0,
                margin: [20, 20, 78, 20],
                width: '1024px',
                height: '768px',
                autoResize: true,
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none'
            });
        };
        onUpdated(() => {
            root.$nextTick(initFancybox);
        });
        onMounted(() => {
            root.$nextTick(initFancybox);
        });
    }
});
